import { BatchDel, ImportUploadFileApI, GetStuScoreAPI, PutStuScoreAPI, BatchExportStudentAPI, GetStudentAPI, DelStudentAPI, DelAllStudentAPI, AddStudentAPI, GetStuDetailAPI, PutStudentAPI } from '@/api/student'

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    // 上传文件
    async uploadFile({ commit }, item) {
      await ImportUploadFileApI(item)
    },
    // 批量导出学生
    async exportStudent() {
      const res = await BatchExportStudentAPI()
      return res
    },
    // 获取学生信息
    async getstudent({ commit }, item) {
      const res = await GetStudentAPI(item)
      return res
    },
    // 删除学生
    async delStudent({ commit }, id) {
      await DelStudentAPI(id)
    },
    // 删除全部的学生
    async delallstudent() {
      await DelAllStudentAPI()
    },
    // 添加学生
    async addstudent({ commit }, item) {
      await AddStudentAPI(item)
    },
    // 获取学生详情
    async getstudetail({ commit }, id) {
      const res = await GetStuDetailAPI(id)
      return res
    },
    // 编辑学生
    async putstu({ commit }, item) {
      await PutStudentAPI(item)
    },
    // 修改学生加分管理
    async putstuscore({ commit }, item) {
      await PutStuScoreAPI(item)
    },
    // 获取学生加分管理
    async getstuscore() {
      const res = await GetStuScoreAPI()
      return res
    },
    // 批量删除毕业生信息列表
    async batchdel({ commit }, item) {
      console.log(item, 999)

      await BatchDel(item)
    }
  }
}
